module.exports = __webpack_public_path__ + "static/media/handrail-flat.fd593df6.jpg";